import * as React from 'react'
import moment from 'moment'
import './styles.scss'

interface SidebarHeaderProps {
  children?: React.ReactNode
}

export const SidebarHeader: React.FC = (props: SidebarHeaderProps) => {
  return <div className='app-sidebar__header'>{props.children}</div>
}

interface SidebarProps {
  displayInPrint?: boolean
  children?: React.ReactNode
}

export const Sidebar: React.FC<SidebarProps> = (props: SidebarProps) => {
  return (
    <div className={'app-sidebar ' + (props.displayInPrint ? 'd-print-none' : '')}>
      {props.children}
    </div>
  )
}

interface SidebarContentProps {
  children?: React.ReactNode
}

export const SidebarContent: React.FC = (props: SidebarContentProps) => {
  return <div className='app-sidebar__content'>{props.children}</div>
}

interface SidebarItemProps {
  active?: boolean
  title?: string
  onClick?: () => void
  date?: string | Date
  dateFormat?: string
  children?: React.ReactNode
}

export const SidebarItem: React.FC<SidebarItemProps> = (props: SidebarItemProps) => {
  const dateFormat = props.dateFormat || 'MMM Do YYYY h:mm a'

  return (
    <div className={`app-sidebar-item ${props.active && 'active'}`} onClick={props.onClick}>
      {props.date && (
        <div className='app-sidebar-item__date'>{moment(props.date).format(dateFormat)}</div>
      )}
      {props.title && <div className='app-sidebar-item__title'>{props.title}</div>}
      {props.children}
    </div>
  )
}
